import { BenchmarkingCriteria } from '@/components/benchmarking/BenchmarkingCriteria';
import { PageTitle } from '@/components/common/PageTitle';

export function Benchmarking() {
  return (
    <div className="container mx-auto py-8">
      <PageTitle title="Benchmarking" />
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2">Benchmarking Study</h1>
        <p className="text-gray-600">
          Assessment framework for DAFCG's boutique consulting firm benchmarking study
        </p>
      </div>
      <BenchmarkingCriteria />
    </div>
  );
}